export function calculateAge(dateString) {
  const birth = new Date(dateString);
  const now = new Date();

  let age = now.getFullYear() - birth.getFullYear();

  // If now is JAN and birth is FEB we are still a year younger
  if (now.getMonth() < birth.getMonth()) {
    age -= 1;
  } else if (
    // else if Now is JAN 1 and BIRTH is JAN 2
    // We are still a year younger.
    now.getMonth() === birth.getMonth() &&
    now.getDate() < birth.getDate()
  ) {
    age -= 1;
  }
  return age;
}

// TODO use Regex in @progleasing/pdk
export const dobRegex = /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](\d{4})$/;
